import React, { useEffect, useState } from 'react'
import { Accordion, Button, Card, Col, Form, Row } from 'react-bootstrap'
import { AccordionEventKey, AccordionSelectCallback } from 'react-bootstrap/esm/AccordionContext'
import { GetAppointmentByIdOutput } from '../../../../Adaptor/TUBSIS/controllers/Appointments/models/getAppointmentModels'
import { GetAppointmentQuestionOutput } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/models/getAppointmentQuestionsModels'
import { getAppointmentQuestionExcelResult, saveAppointmentQuestions } from '../../../../Adaptor/TUBSIS/controllers/AppointmentQuestions/AppointmentQuestions'

type Props = { appointment: GetAppointmentByIdOutput, propAppointmentQuestions: GetAppointmentQuestionOutput[] }

const PatientAppointmentWEMIOOQuestions: React.FC<Props> = ({ appointment, propAppointmentQuestions }) => {

    const [activeQuestionAccordion, setActiveQuestionAccordion] = useState<AccordionEventKey | null>(null)

    const toggleQuestionAccordion: AccordionSelectCallback = (eventKey: AccordionEventKey) => {
        setActiveQuestionAccordion(eventKey === activeQuestionAccordion ? null : eventKey)
    }

    const [appointmentId, setAppointmentId] = useState<number | null>(null)
    const [questionGroupPuan, setQuestionGroupPuan] = useState<number | null>(null)
    const [questionGroupPuanValid, setQuestionGroupPuanValid] = useState<boolean>(false)
    const [question11, setQuestion11] = useState<string | null>(null)
    const [question12, setQuestion12] = useState<string | null>(null)
    const [question13, setQuestion13] = useState<string | null>(null)
    const [question14, setQuestion14] = useState<string | null>(null)
    const [question15, setQuestion15] = useState<string | null>(null)
    const [question16, setQuestion16] = useState<string | null>(null)
    const [question17, setQuestion17] = useState<string | null>(null)

    const [question11Point, setQuestion11Point] = useState<number | null>(null)
    const [question12Point, setQuestion12Point] = useState<number | null>(null)
    const [question13Point, setQuestion13Point] = useState<number | null>(null)
    const [question14Point, setQuestion14Point] = useState<number | null>(null)
    const [question15Point, setQuestion15Point] = useState<number | null>(null)
    const [question16Point, setQuestion16Point] = useState<number | null>(null)
    const [question17Point, setQuestion17Point] = useState<number | null>(null)

    const [isValidQuestion11, setIsValidQuestion11] = useState<boolean>(false)
    const [isValidQuestion12, setIsValidQuestion12] = useState<boolean>(false)
    const [isValidQuestion13, setIsValidQuestion13] = useState<boolean>(false)
    const [isValidQuestion14, setIsValidQuestion14] = useState<boolean>(false)
    const [isValidQuestion15, setIsValidQuestion15] = useState<boolean>(false)
    const [isValidQuestion16, setIsValidQuestion16] = useState<boolean>(false)
    const [isValidQuestion17, setIsValidQuestion17] = useState<boolean>(false)

    const getChoiceValue = (choiceId: number): number => {
        switch (choiceId) {
            case 30:
            case 35:
            case 40:
            case 45:
            case 50:
            case 55:
            case 60:
                return 1;
            case 31:
            case 36:
            case 41:
            case 46:
            case 51:
            case 56:
            case 61:
                return 2;
            case 32:
            case 37:
            case 42:
            case 47:
            case 52:
            case 57:
            case 62:
                return 3;
            case 33:
            case 38:
            case 43:
            case 48:
            case 53:
            case 58:
            case 63:
                return 4;
            case 34:
            case 39:
            case 44:
            case 49:
            case 54:
            case 59:
            case 64:
                return 5;
            default:
                return 0;
        }
    };

    const [appointmentQuestions, setAppointmentQuestions] = useState<GetAppointmentQuestionOutput[] | null>(null)

    useEffect(() => {
        if (appointment && appointment.appointmentId > 0) {

                    if (propAppointmentQuestions && propAppointmentQuestions !== null && propAppointmentQuestions.length > 0) {
                        // console.log("girdi", JSON.stringify(response.data))
                        setAppointmentQuestions(propAppointmentQuestions)
                        propAppointmentQuestions.forEach(aq => {
                            if (aq.questionId && aq.questionId === 11) {
                                setQuestion11(aq.choiceId.toString())
                                setIsValidQuestion11(true);
                                setQuestion11Point(aq.point)

                            } else if (aq.questionId && aq.questionId === 12) {
                                setQuestion12(aq.choiceId.toString())
                                setIsValidQuestion12(true);
                                setQuestion12Point(aq.point)

                            } else if (aq.questionId && aq.questionId === 13) {
                                setQuestion13(aq.choiceId.toString())
                                setIsValidQuestion13(true);
                                setQuestion13Point(aq.point)

                            } else if (aq.questionId && aq.questionId === 14) {
                                setQuestion14(aq.choiceId.toString())
                                setIsValidQuestion14(true);
                                setQuestion14Point(aq.point)

                            } else if (aq.questionId && aq.questionId === 15) {
                                setQuestion15(aq.choiceId.toString())
                                setIsValidQuestion15(true);
                                setQuestion15Point(aq.point)

                            } else if (aq.questionId && aq.questionId === 16) {
                                setQuestion16(aq.choiceId.toString())
                                setIsValidQuestion16(true);
                                setQuestion16Point(aq.point)
                            } else if (aq.questionId && aq.questionId === 17) {
                                setQuestion17(aq.choiceId.toString())
                                setIsValidQuestion17(true);
                                setQuestion17Point(aq.point)
                            }
                        });

                        const totalPoints = propAppointmentQuestions.filter(q => [11, 12, 13, 14, 15, 16, 17].includes(q.questionId)).reduce((total, aq) => total + aq.point, 0);

                        if (propAppointmentQuestions && propAppointmentQuestions !== null && propAppointmentQuestions.length > 0) {
                            setQuestionGroupPuan(totalPoints)
                            setQuestionGroupPuanValid(true)
                        } else {
                            setQuestionGroupPuanValid(false)
                        }
                    }

                    setAppointmentId(appointment.appointmentId)

        }
    }, [appointment])

    const handleUpdate = async () => {
        // Form verilerini güncellemek için gerekli işlemleri burada gerçekleştirin
        // console.log("Form verileri güncellendi:", userData);

        if (!appointmentId) {
            alert("Randevu bilgisine ulaşılamadığı için WEMİOÖ Testi kaydedilemedi.")
            return;
        }

        if (!question11 || !question12 || !question13 || !question14 || !question15 || !question16 || !question17) {
            return;
        }

        if (!isValidQuestion11 || !isValidQuestion12 || !isValidQuestion13 || !isValidQuestion14 || 
            !isValidQuestion15 || !isValidQuestion16 || !isValidQuestion17) {
            return;
        }

        const requestModel = {
            appointmentQuestionGroup: {
                appointmentId: appointmentId,
                appointmentQuestions: [{
                    questionId: 11,
                    choiceId: parseInt(question11),
                    point: question11Point ?? 0
                }, {
                    questionId: 12,
                    choiceId: parseInt(question12),
                    point: question12Point ?? 0
                }, {
                    questionId: 13,
                    choiceId: parseInt(question13),
                    point: question13Point ?? 0
                }, {
                    questionId: 14,
                    choiceId: parseInt(question14),
                    point: question14Point ?? 0
                }, {
                    questionId: 15,
                    choiceId: parseInt(question15),
                    point: question15Point ?? 0
                }, {
                    questionId: 16,
                    choiceId: parseInt(question16),
                    point: question16Point ?? 0
                }, {
                    questionId: 17,
                    choiceId: parseInt(question17),
                    point: question17Point ?? 0
                }]
            }
        }

        // console.log("rqq",JSON.stringify(requestModel))

        var response = await saveAppointmentQuestions(requestModel)

        if (response.success) {
            alert("WEMİOÖ(Mental İyi Oluş) Testi kaydedildi.")
        } else {
            alert("WEMİOÖ Testi kaydedilirken bir sorun oluştu: " + response.message)
        }
        // window.location.reload()
    }

    const handleOptionClick11 = (optionId: string) => {
        if (question11 === optionId) {
            setQuestion11(null); // Seçiliyse geri al
            setIsValidQuestion11(false)
            setQuestion11Point(0)
        } else {
            setQuestion11(optionId); // Değilse seç
            setIsValidQuestion11(true)
            setQuestion11Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick12 = (optionId: string) => {
        if (question12 === optionId) {
            setQuestion12(null); // Seçiliyse geri al
            setIsValidQuestion12(false)
            setQuestion12Point(0)
        } else {
            setQuestion12(optionId); // Değilse seç
            setIsValidQuestion12(true)
            setQuestion12Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick13 = (optionId: string) => {
        if (question13 === optionId) {
            setQuestion13(null); // Seçiliyse geri al
            setIsValidQuestion13(false)
            setQuestion13Point(0)
        } else {
            setQuestion13(optionId); // Değilse seç
            setIsValidQuestion13(true)
            setQuestion13Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick14 = (optionId: string) => {
        if (question14 === optionId) {
            setQuestion14(null); // Seçiliyse geri al
            setIsValidQuestion14(false)
            setQuestion14Point(0)
        } else {
            setQuestion14(optionId); // Değilse seç
            setIsValidQuestion14(true)
            setQuestion14Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick15 = (optionId: string) => {
        if (question15 === optionId) {
            setQuestion15(null); // Seçiliyse geri al
            setIsValidQuestion15(false)
            setQuestion15Point(0)
        } else {
            setQuestion15(optionId); // Değilse seç
            setIsValidQuestion15(true)
            setQuestion15Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick16 = (optionId: string) => {
        if (question16 === optionId) {
            setQuestion16(null); // Seçiliyse geri al
            setIsValidQuestion16(false)
            setQuestion16Point(0)
        } else {
            setQuestion16(optionId); // Değilse seç
            setIsValidQuestion16(true)
            setQuestion16Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleOptionClick17 = (optionId: string) => {
        if (question17 === optionId) {
            setQuestion17(null); // Seçiliyse geri al
            setIsValidQuestion17(false)
            setQuestion17Point(0)
        } else {
            setQuestion17(optionId); // Değilse seç
            setIsValidQuestion17(true)
            setQuestion17Point(getChoiceValue(parseInt(optionId)))
        }
    };

    const handleExcelResultClick = (appointmentId: number, type: number) => {
        // Butona tıklandığında yapılacak işlemler buraya yazılır
        // console.log('Butona tıklandı!');

        if (!appointmentId) {
            alert("Randevu bilgileri getirilemediğinden excel alınamıyor.")
            return;
        }

        getAppointmentQuestionExcelResult(appointmentId, 15003, appointment.appointmentStartDate)//WEMİOÖ
    };

    return (

        <Accordion activeKey={activeQuestionAccordion} onSelect={toggleQuestionAccordion}>
            <Card key={'2'}>
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center w-100'>
                        <Button className='d-flex justify-content-between align-items-center w-100' variant='link' onClick={(e) => toggleQuestionAccordion('2', e)}>
                            <div className='text-left text-gray-700'>{"Mental İyi Oluş Testi"}</div>
                            <div className='text-center text-gray-700 fs-7' style={{paddingRight:"35px"}}>{questionGroupPuanValid ? `PUAN: ${questionGroupPuan ?? 0}` : "TEST DOLDURULMADI"}</div>
                            <div className='text-right'></div>
                        </Button>
                        <div></div>
                        <button
                            type="button"
                            about='Excel'
                            title='WEMİOÖ Test Sonucunu İndir'
                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                            onClick={() => handleExcelResultClick(appointmentId ?? 0, 15003)}>
                            {/* 15001: HAPA Excel Type
                                15002: FNBT Excel Type 
                                15003: WEMİOÖ Excel Type
                            */}
                            <i className="ki-duotone ki-file-down fs-2"><span className="path1"></span><span className="path2"></span></i>
                        </button>
                    </div>
                </Card.Header>
                <Accordion.Collapse eventKey={'2'}>
                    <Card.Body>
                        <Form onSubmit={handleUpdate}>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Gelecek konusunda iyimserim.</Form.Label>
                                    <div className="d-grid gap-2">
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question11 === '30' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick11('30')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question11 === '31' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick11('31')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question11 === '32' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick11('32')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question11 === '33' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick11('33')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question11 === '34' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick11('34')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion11 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Kendimi işe yarar hissediyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question12 === '35' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick12('35')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question12 === '36' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick12('36')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question12 === '37' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick12('37')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question12 === '38' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick12('38')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question12 === '39' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick12('39')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion12 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Kendimi rahat hissediyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question13 === '40' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick13('40')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question13 === '41' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick13('41')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question13 === '42' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick13('42')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question13 === '43' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick13('43')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question13 === '44' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick13('44')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion13 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Sorunlarla iyi bir biçimde başa çıkıyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question14 === '45' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick14('45')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question14 === '46' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick14('46')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question14 === '47' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick14('47')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question14 === '48' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick14('48')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question14 === '49' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick14('49')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion14 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>
                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Sağlıklı düşünüyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question15 === '50' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick15('50')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question15 === '51' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick15('51')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question15 === '52' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick15('52')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question15 === '53' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick15('53')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question15 === '54' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick15('54')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion15 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Çevremdeki diğer insanlara kendimi yakın hissediyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question16 === '55' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick16('55')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question16 === '56' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick16('56')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question16 === '57' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick16('57')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question16 === '58' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick16('58')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question16 === '59' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick16('59')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion16 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-14'>
                                <Form.Group as={Col}>
                                    <Form.Label>Kendi kararlarımı kendim verebiliyorum.</Form.Label>
                                    <div className="d-grid gap-2">
                                    <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question17 === '60' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick17('60')}
                                        >
                                            Hiçbir zaman
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question17 === '61' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick17('61')}
                                        >
                                            Nadiren
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question17 === '62' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick17('62')}
                                        >
                                            Bazen
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question17 === '63' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick17('63')}
                                        >
                                            Sık sık
                                        </Button>
                                        <Button
                                            style={{ border: "1px solid #a9a9a9" }}
                                            variant={question17 === '64' ? 'primary' : 'outline-primary'}
                                            onClick={() => handleOptionClick17('64')}
                                        >
                                            Her zaman
                                        </Button>
                                        <Form.Control.Feedback type="invalid" style={{ display: isValidQuestion17 ? 'none' : 'block' }}>
                                            Lütfen seçim yapınız.
                                        </Form.Control.Feedback>
                                    </div>
                                </Form.Group>
                            </Row>

                            <Row className='mb-3 mt-10'>
                                <Form.Group as={Col}>
                                    <Button variant='primary' onClick={handleUpdate}>
                                        Kaydet
                                    </Button>
                                </Form.Group>
                            </Row>
                        </Form>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default PatientAppointmentWEMIOOQuestions
